export const ADD_TO_CART = 'ADD_TO_CART';
export const COMING_SOON = 'COMING_SOON';
export const NOTIFY_IF_BACK = 'NOTIFY_IF_BACK';
export const OUT_OF_STOCK = 'OUT_OF_STOCK';
export const getSizePickerState = ({ inStock, comingSoon, nib, selectedVariant, isPreAccessEnabled, isUserEligible, }) => {
    var _a;
    const selectedVariantInStock = !!((_a = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.stock) === null || _a === void 0 ? void 0 : _a.stockLevel);
    if ((inStock &&
        !comingSoon &&
        !isPreAccessEnabled &&
        (!selectedVariant || (selectedVariant && selectedVariantInStock))) ||
        (isPreAccessEnabled && inStock && isUserEligible)) {
        return ADD_TO_CART;
    }
    if ((comingSoon && !isPreAccessEnabled) || (isPreAccessEnabled && !isUserEligible)) {
        return COMING_SOON;
    }
    if (nib) {
        return NOTIFY_IF_BACK;
    }
    return OUT_OF_STOCK;
};
//# sourceMappingURL=getSizePickerState.js.map